import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';

import { BaseService } from '../../base/util/base.service';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { URL_ALTERAR_IMAGEM_PRESTADOR }  from '../../base/util/url-util';

@Injectable()
export class UsuarioDashboardService extends BaseService{

	public isImagemPerfilAlterada = new Subject<boolean>();
    
    constructor(public http: HttpClient,public messageService: MessageService){
        super(http,messageService);        
    }
    
    alterarImagemPerfil(file: File) {
    	let formData: FormData = new FormData();
    	formData.append("file", file);
    	return this.post(URL_ALTERAR_IMAGEM_PRESTADOR, formData, new HttpHeaders().set('Accept', 'application/json'));
    }
    
    emitIsImagemPerfilAlterada(val) {
    	this.isImagemPerfilAlterada.next(val);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dashboard/usuario-dashboard/usuario-dashboard.service.ts